import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AuthService } from '../services/services.index';
import { AppCore } from '../app.core';

@Injectable()
export class SocioProfileGuard extends AppCore implements CanActivate {

  private usuario: any;

  constructor(
    private _auth: AuthService,
    private _router: Router
  ) {
    super();
  }

  canActivate() {
    this.usuario = this._auth.getUser();
    if ([1, 2].indexOf(parseInt(this.usuario.rol.nivel)) < 0) {
      this.setMensaje('Sin permisos', 'Debe tener permisos de socio para poder ingresar a este enlace', 'error');
      this._router.navigate(['/dashboard']);
      return false;
    }
    return true;
  }
}


// WEBPACK FOOTER //
// ./src/app/guards/socio-profile.guard.ts